export default {
    setModelFrontLogsQueryParams: (state, action) => {
        state.queryParams = action.payload;
    },
    clearModelFrontLogsFilters: (state) => {
        const today = new Date().toISOString().split('T')[0];
        state.queryParams = {
            ...state.queryParams,
            page: 1,
            sortDirection: 'DESC',
            createdAtMin: today,
            createdAtMax: today,
        };
    },
};
